// src/campaigns/components/CampaignMeta.tsx

import { Helmet } from "react-helmet-async";
import { useCampaignMeta } from "../hooks/useCampaignMeta";

export function CampaignMeta() {
  const { title, description, imageUrl, themeColor } = useCampaignMeta();

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:image:secure_url" content={imageUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="LRNSY" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />

      <meta name="theme-color" content={themeColor} />
    </Helmet>
  );
}
